import { render, staticRenderFns } from "./EditPattern.vue?vue&type=template&id=fbedc072&scoped=true"
import script from "./EditPattern.vue?vue&type=script&lang=js"
export * from "./EditPattern.vue?vue&type=script&lang=js"
import style0 from "./EditPattern.vue?vue&type=style&index=0&id=fbedc072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbedc072",
  null
  
)

export default component.exports